import ActionTypes from '../constants/ActionTypes';

const fetchCardPointAdvancedData = (cardId) => ({
  type: ActionTypes.CARD_POINT_ADVANCED_DATA_FETCH,
  payload: {
    cardId,
  },
});

fetchCardPointAdvancedData.success = (cardId, pointSystemId, items) => ({
  type: ActionTypes.CARD_POINT_ADVANCED_DATA_FETCH__SUCCESS,
  payload: {
    cardId,
    pointSystemId,
    items,
  },
});

fetchCardPointAdvancedData.failure = (cardId, error) => ({
  type: ActionTypes.CARD_POINT_ADVANCED_DATA_FETCH__FAILURE,
  payload: {
    cardId,
    error,
  },
});

const createCardPointAdvancedData = (cardId, data) => ({
  type: ActionTypes.CARD_POINT_ADVANCED_DATA_CREATE,
  payload: {
    cardId,
    data,
  },
});

createCardPointAdvancedData.success = (item) => ({
  type: ActionTypes.CARD_POINT_ADVANCED_DATA_CREATE__SUCCESS,
  payload: {
    item,
  },
});

createCardPointAdvancedData.failure = (cardId, error) => ({
  type: ActionTypes.CARD_POINT_ADVANCED_DATA_CREATE__FAILURE,
  payload: {
    cardId,
    error,
  },
});

const updateCardPointAdvancedData = (id, data) => ({
  type: ActionTypes.CARD_POINT_ADVANCED_DATA_UPDATE,
  payload: {
    id,
    data,
  },
});

updateCardPointAdvancedData.success = (item) => ({
  type: ActionTypes.CARD_POINT_ADVANCED_DATA_UPDATE__SUCCESS,
  payload: {
    item,
  },
});

updateCardPointAdvancedData.failure = (id, error) => ({
  type: ActionTypes.CARD_POINT_ADVANCED_DATA_UPDATE__FAILURE,
  payload: {
    id,
    error,
  },
});

const deleteCardPointAdvancedData = (id) => ({
  type: ActionTypes.CARD_POINT_ADVANCED_DATA_DELETE,
  payload: {
    id,
  },
});

deleteCardPointAdvancedData.success = (item) => ({
  type: ActionTypes.CARD_POINT_ADVANCED_DATA_DELETE__SUCCESS,
  payload: {
    item,
  },
});

deleteCardPointAdvancedData.failure = (id, error) => ({
  type: ActionTypes.CARD_POINT_ADVANCED_DATA_DELETE__FAILURE,
  payload: {
    id,
    error,
  },
});

export default {
  fetchCardPointAdvancedData,
  createCardPointAdvancedData,
  updateCardPointAdvancedData,
  deleteCardPointAdvancedData,
};

